import {
  DeleteTarget,
  DeleteTargetVariables,
} from "_graphql/mutation/__generated__/DeleteTarget";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import { deleteTarget } from "../../_graphql/visal/mutations/target";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";
import { useTarget } from "hooks/data/use-targets";

export default function RemoveTargetContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { loading, targetBadge } = useTarget({
    targetId: searchParams?.id || "",
  });

  const [execute, { loading: deleting }] = useMutation<
    DeleteTarget,
    DeleteTargetVariables
  >(deleteTarget, {
    refetchQueries: ["fetchTargets"],
  });

  const handleSubmit = async () => {
    await execute({
      variables: {
        id: searchParams?.id || "",
      },
    })
      .then(({ data }) => {
        if (data?.deleteTarget) {
          toast.success("Target deleted successfully");
          refetch?.();
          setOpen(false);
        } else {
          toast.error("Failed to delete Target");
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Delete Target"
      cancelText="No, Don't Delete Target"
      description={`Are you sure you want to delete the target "${targetBadge?.target_name}"? This will permanently delete the target and all its associated badges. This action cannot be undone.`}
      renderActions={() => (
        <button
          type="button"
          disabled={deleting}
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
          onClick={handleSubmit}
        >
          {deleting ? "Deleting..." : "Delete Target"}
        </button>
      )}
    />
  );
}
